import { TextInitial } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TextInitialIcon = createLucideIcon(TextInitial);
